// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1iQOM","upload":"Small_upload__1FqUu","imageWrap":"Small_imageWrap__1bFS9","removeBtn":"Small_removeBtn__1x1Zp"};